import { Checkbox, Input } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { HiOutlineArrowLeft, HiOutlineArrowRight } from 'react-icons/hi';

import { confirmarCodigo, reenviarCodigo } from '../../../operations/auth';
import {
  BackButton,
  CodigoAjuda,
  CodigoErro,
  CodigoReenvio,
  CodigoWrapper,
  FormWrapper,
  LoginCard,
  LoginSubtitle,
  SubmitButton,
} from './styles';

// Segundo passo do login: o código de 6 dígitos que chegou por e-mail.
export const VerificacaoCodigo = ({ desafio: desafioInicial, onConfirmado, onVoltar }) => {
  const [desafio, setDesafio] = useState(desafioInicial);
  const [codigo, setCodigo] = useState('');
  const [lembrar, setLembrar] = useState(true);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState('');
  const [aviso, setAviso] = useState('');
  const [espera, setEspera] = useState(desafioInicial.reenviar_em || 60);
  const campo = useRef(null);

  useEffect(() => {
    if (espera <= 0) return undefined;
    const timer = setTimeout(() => setEspera(espera - 1), 1000);
    return () => clearTimeout(timer);
  }, [espera]);

  const mensagemDoErro = (error, padrao) => {
    const resposta = (error && error.response && error.response.data) || {};
    if (resposta.refazer_login) {
      onVoltar(resposta.message || 'O código expirou. Entre de novo com a sua senha.');
      return null;
    }
    return resposta.message || padrao;
  };

  const confirmar = async (valor) => {
    if (enviando || valor.length !== 6) return;
    setEnviando(true);
    setErro('');
    setAviso('');
    try {
      const resposta = await confirmarCodigo(desafio.desafio, valor, lembrar);
      await onConfirmado(resposta);
    } catch (error) {
      const mensagem = mensagemDoErro(error, 'Não foi possível confirmar o código. Tente de novo.');
      if (mensagem === null) return;
      setErro(mensagem);
      setCodigo('');
      setEnviando(false);
      if (campo.current) campo.current.focus();
    }
  };

  const alterarCodigo = (e) => {
    const valor = (e.target.value || '').replace(/\D/g, '').slice(0, 6);
    setCodigo(valor);
    if (erro) setErro('');
    if (valor.length === 6) confirmar(valor);
  };

  const reenviar = async () => {
    if (espera > 0 || enviando) return;
    setErro('');
    setAviso('');
    try {
      const novo = await reenviarCodigo(desafio.desafio);
      setDesafio(novo);
      setEspera(novo.reenviar_em || 60);
      setCodigo('');
      setAviso('Enviamos um código novo.');
    } catch (error) {
      const mensagem = mensagemDoErro(error, 'Não foi possível reenviar agora.');
      if (mensagem !== null) setErro(mensagem);
    }
  };

  return (
    <LoginCard>
      <LoginSubtitle>
        Enviamos um código de 6 dígitos para <strong>{desafio.email}</strong>. Digite-o abaixo
        para entrar.
      </LoginSubtitle>
      <FormWrapper>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            confirmar(codigo);
          }}
        >
          <CodigoWrapper>
            <Input
              ref={campo}
              value={codigo}
              onChange={alterarCodigo}
              autoFocus
              disabled={enviando}
              inputMode="numeric"
              autoComplete="one-time-code"
              maxLength={6}
              placeholder="000000"
              aria-label="Código de acesso"
            />
          </CodigoWrapper>
          {erro ? <CodigoErro>{erro}</CodigoErro> : aviso && <CodigoAjuda>{aviso}</CodigoAjuda>}

          <div style={{ margin: '16px 0 24px' }}>
            <Checkbox checked={lembrar} onChange={(e) => setLembrar(e.target.checked)}>
              Lembrar deste dispositivo por 30 dias
            </Checkbox>
          </div>

          <SubmitButton type="submit" disabled={enviando || codigo.length !== 6}>
            {enviando ? 'Confirmando...' : 'Confirmar'}
            {!enviando && <HiOutlineArrowRight />}
          </SubmitButton>
        </form>

        <CodigoReenvio>
          {espera > 0 ? (
            <span>Reenviar código em {espera}s</span>
          ) : (
            <button type="button" onClick={reenviar}>
              Reenviar código
            </button>
          )}
        </CodigoReenvio>
        <CodigoAjuda>Não chegou? Confira o spam. O código vale por 10 minutos.</CodigoAjuda>
      </FormWrapper>
      <BackButton onClick={() => onVoltar('')}>
        <HiOutlineArrowLeft />
        Voltar para login
      </BackButton>
    </LoginCard>
  );
};
